// extracted by mini-css-extract-plugin
export const vacancies = "K_cs";
export const vacancies_heading = "K_ct";
export const vacancies_inner = "K_cv";
export const vacancies_list = "K_cw";
export const vacancies_item = "K_cx";
export const vacancies_position = "K_cy";
export const vacancies_label = "K_cz";
export const vacancies_empty = "K_cB";
export const vacancies_descr = "K_cC";